(() => {
  const config = document.getElementById('pluffi-reviewed-copy');
  if (!config) return;
  const {lang, records} = JSON.parse(config.textContent);
  const labels = {
    fr: ['Traduit de l’anglais', 'Afficher l’original', 'Afficher la traduction', 'Diapositive', 'Page', 'Page précédente', 'Page suivante', 'Pagination', 'sur 5 étoiles'],
    it: ['Tradotto dall’inglese', 'Mostra originale', 'Mostra traduzione', 'Diapositiva', 'Pagina', 'Pagina precedente', 'Pagina successiva', 'Paginazione', 'su 5 stelle'],
    es: ['Traducido del inglés', 'Mostrar original', 'Mostrar traducción', 'Diapositiva', 'Página', 'Página anterior', 'Página siguiente', 'Paginación', 'de 5 estrellas'],
    de: ['Aus dem Englischen übersetzt', 'Original anzeigen', 'Übersetzung anzeigen', 'Folie', 'Seite', 'Vorherige Seite', 'Nächste Seite', 'Seitennavigation', 'von 5 Sternen']
  }[lang];
  if (!labels) return;
  const normalize = text => text.replace(/\s+/g, ' ').trim();
  const lookup = new Map(records.map(row => [normalize(row[0]), row]));
  const seen = new WeakMap();
  const products = JSON.parse(document.getElementById('pluffi-review-products')?.textContent || '{}');
  products['Pluffi | La Pantofola Morbida e Stile'] = products['Chaussons Pluffi'];
  const viewProduct = {fr:'Voir le produit',it:'Vedi il prodotto',es:'Ver el producto',de:'Produkt ansehen'}[lang];
  const openReviewProduct = event => {
    const target = event.target.closest('[data-pluffi-review-url]');
    if (!target || (event.type === 'keydown' && !['Enter',' '].includes(event.key))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(target.dataset.pluffiReviewUrl);
  };
  document.addEventListener('click', openReviewProduct, true);
  document.addEventListener('keydown', openReviewProduct, true);
  const translate = () => {
    document.querySelectorAll('.jdgm-review-content__body-content, .pluffi-shop-reviews .jdgm-card .jdgm-text').forEach(body => {
      const text = normalize(body.textContent);
      const previous = seen.get(body);
      const review = body.closest('.jm-review-item, .jdgm-card');
      const identity = review?.getAttribute('review-uuid') || review?.getAttribute('data-review-id');
      const row = lookup.get(text) || (previous && identity && previous.identity === identity ? previous.row : null);
      // Only the verified imported batch is translated; new or unmatched reviews stay native.
      if (!row) {
        if (previous) {
          previous.panel?.remove();
          body.hidden = false;
          delete body.dataset.pluffiOriginal;
          seen.delete(body);
        }
        return;
      }
      let state = previous;
      if (!state || state.row !== row) {
        previous?.panel?.remove();
        state = {row, source: text, identity};
      }
      if (!state.panel?.isConnected) {
        // Carousel clones copy the translated DOM but not its event handlers.
        let sibling = body.nextElementSibling;
        while (sibling?.classList.contains('pluffi-review-copy')) {
          const next = sibling.nextElementSibling;
          sibling.remove();
          sibling = next;
        }
        const panel = document.createElement('div');
        panel.className = 'pluffi-review-copy';
        panel.dataset.pluffiTranslated = lang;
        const content = document.createElement('p');
        content.textContent = row[1];
        const controls = document.createElement('div');
        controls.className = 'pluffi-review-copy__controls';
        const note = document.createElement('span');
        note.textContent = labels[0] + ' · ';
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.textContent = labels[1];
        toggle.setAttribute('aria-pressed', 'false');
        toggle.addEventListener('click', () => {
          const showOriginal = toggle.getAttribute('aria-pressed') !== 'true';
          content.textContent = showOriginal ? row[0] : row[1];
          content.lang = showOriginal ? 'en' : lang;
          toggle.textContent = showOriginal ? labels[2] : labels[1];
          toggle.setAttribute('aria-pressed', String(showOriginal));
        });
        content.lang = lang;
        controls.append(note, toggle);
        panel.append(content, controls);
        body.after(panel);
        state.panel = panel;
      }
      // Keep the original app-owned review, author, rating and date intact.
      if (!body.hidden) body.hidden = true;
      body.dataset.pluffiOriginal = 'true';
      seen.set(body, state);
    });
    document.querySelectorAll('.jm-product-variant-card__thumbnail, .jm-product-variant-card__product-link').forEach(el => {
      const source = el.getAttribute('aria-label')?.match(/^View (.+) product page$/)?.[1] || el.dataset.pluffiReviewSource;
      const product = products[source];
      if (!product?.url || !product.title) return;
      el.dataset.pluffiReviewSource = source;
      el.dataset.pluffiReviewUrl = product.url;
      const label = viewProduct + ' : ' + product.title;
      if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
      if (el.classList.contains('jm-product-variant-card__product-link') && el.textContent !== product.title) el.textContent = product.title;
      const img = el.querySelector('img');
      if (img && img.alt !== product.title) img.alt = product.title;
    });
    document.querySelectorAll('button[aria-label], [role="img"][aria-label], nav[aria-label]').forEach(el => {
      const value = el.getAttribute('aria-label');
      let next;
      let match;
      if ((match = value.match(/^Go to slide (?:group )?(\d+)$/))) next = labels[3] + ' ' + match[1];
      else if ((match = value.match(/^Go to page (\d+)$/))) next = labels[4] + ' ' + match[1];
      else if (value === 'Go to previous page') next = labels[5];
      else if (value === 'Go to next page') next = labels[6];
      else if (value === 'Pagination Navigation') next = labels[7];
      else if ((match = value.match(/^([\d.]+) out of 5 stars$/))) next = match[1] + ' ' + labels[8];
      if (next) el.setAttribute('aria-label', next);
    });
  };
  const style = document.createElement('style');
  style.textContent = '[data-pluffi-original]{display:none!important}.pluffi-review-copy>p{margin:0;white-space:pre-line}.pluffi-review-copy__controls{font-size:12px;line-height:1.5;margin-top:8px}.pluffi-review-copy__controls button{color:inherit;background:none;border:0;padding:4px 0;font:inherit;text-decoration:underline;cursor:pointer}.jm-review-item:has([data-pluffi-translated]) .jdgm-translate-button,.jm-review-item:has([data-pluffi-translated]) .jdgm-translate-icon{display:none!important}.jdgm-card .pluffi-review-copy>p{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}.jdgm-card .pluffi-review-copy__controls{font-size:11px}';
  document.head.append(style);
  translate();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; translate(); });
  }).observe(document.body, {childList: true, subtree: true, characterData: true});
})();
